import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PopupMenu,
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';

export type CalendarSyncMenuProps = {
  isSynced: boolean;
  isHidden: boolean;
  onToggleSync: () => void;
  onToggleVisibility: () => void;
  onClose: () => void;
  referenceElement: React.RefObject<HTMLElement>;
};

// The calendar-sync actions for one task, shared by the calendar event card's
// badge and the task-detail header button so the two can't drift apart.
export const CalendarSyncMenu: React.FC<CalendarSyncMenuProps> = ({
  isSynced,
  isHidden,
  onToggleSync,
  onToggleVisibility,
  onClose,
  referenceElement,
}) => {
  const { t } = useTranslation();

  const onSyncClick = () => {
    onToggleSync();
    onClose();
  };

  const onVisibilityClick = () => {
    onToggleVisibility();
    onClose();
  };

  return (
    <PopupMenu
      referenceElement={referenceElement}
      onOutside={onClose}
      position="bottom-end"
    >
      <PopupMenuList>
        <PopupMenuListItem>
          <PopupMenuButton onClick={onSyncClick}>
            {t(
              isSynced
                ? 'calendar.event-sync.stop'
                : 'calendar.event-sync.start',
            )}
          </PopupMenuButton>
        </PopupMenuListItem>
        {isSynced && (
          <PopupMenuListItem>
            <PopupMenuButton onClick={onVisibilityClick}>
              {t(
                isHidden
                  ? 'calendar.event-sync.show-details'
                  : 'calendar.event-sync.hide-details',
              )}
            </PopupMenuButton>
          </PopupMenuListItem>
        )}
      </PopupMenuList>
    </PopupMenu>
  );
};
